// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileModalTabs_wrapper__1B3LN","openBtn":"ProfileModalTabs_openBtn__m6hHg"};